import { IMucThuKhacSinhVienSaveHocPhiTinChiRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienSaveHocPhiTinChiRequest";
import { IMucThuTinChiDuyetLopTuNguyenRequest } from "../../model/request/chung-tu/IMucThuTinChiDuyetLopTuNguyenRequest";
import { IMucThuTinChiGanMucThuRequest } from "../../model/request/chung-tu/IMucThuTinChiGanMucThuRequest";
import { IDanhSachLopTinChiSelectByLopTcRequest } from "../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectByLopTcRequest";
import { IDanhSachLopTinChiSelectRequest } from "../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectRequest";
import { ILopTuNguyenSelectRequest } from "../../model/request/lop-tin-chi/ILopTuNguyenSelectRequest";
import { apiClient } from "../apiClient";
export const MUC_THU_KHAC_SINH_VIEN = "muc-thu-khac-tin-chi";
export interface IMucThuTinChiTheoSinhVienRequest {
    id_sv: string;
    hoc_ky: number;
    nam_hoc: string;
    id_thu_chi: number;
}

export interface IMucThuTinChiSaveTheoSinhVienRequest
    extends IMucThuTinChiTheoSinhVienRequest {
    ky_dang_kys: number[];
    /** Đơn giá GỐC người dùng sửa tay theo từng lớp tín chỉ (chỉ gồm lớp bị sửa).
     *  ghi_chu: lý do sửa giá — bỏ trống (undefined) = giữ ghi chú đang có; chuỗi rỗng = xóa. */
    don_gia_sua_tays?: { id_lop_tc: number; don_gia: number; ghi_chu?: string }[];
}

export interface IResetDonGiaTinChiRequest {
    id_sv: string;
    ky_dang_ky: number;
    id_lop_tcs: number[];
    /** true = đã duyệt → tổng hợp lại + duyệt lại; false = đã tổng hợp chưa duyệt → chỉ tổng hợp lại. */
    duyet?: boolean;
}

export const mucThuKhacTinChiSinhVienApi = {
    Caculate: (request:IDanhSachLopTinChiSelectRequest) => apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/caculate`,request),
    SaveCaculate: (request:IMucThuKhacSinhVienSaveHocPhiTinChiRequest) => apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/save`,request),
    SelectTheoSinhVien: (request:IMucThuTinChiTheoSinhVienRequest) => apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-theo-sinh-vien`,request),
    SaveTheoSinhVien: (request:IMucThuTinChiSaveTheoSinhVienRequest) => apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/save-theo-sinh-vien`,request),
    ResetDonGiaTheoSinhVien: (request: IResetDonGiaTinChiRequest, process_id: string) =>
        apiClient.put(`${MUC_THU_KHAC_SINH_VIEN}/reset-don-gia-theo-sinh-vien?process_id=${process_id}`, request),
    /** CHỈ sửa ghi chú của học phần đang sửa tay đơn giá (không đổi giá, không tổng hợp lại). */
    CapNhatGhiChuDonGiaSuaTay: (request: { id_sv: string; items: { id_lop_tc: number; ghi_chu: string }[] }) =>
        apiClient.put(`${MUC_THU_KHAC_SINH_VIEN}/ghi-chu-don-gia-sua-tay`, request),
    /** Hủy duyệt đợt của 1 SV; go_tong_hop=true thì gỡ luôn mức thu (về "Chưa tổng hợp"). */
    HuyDuyetTheoSinhVien: (
        request: { id_sv: string; ky_dang_ky: number; go_tong_hop: boolean },
        process_id: string,
    ) =>
        apiClient.put(`${MUC_THU_KHAC_SINH_VIEN}/huy-duyet-theo-sinh-vien?process_id=${process_id}`, request),

    /** Hủy duyệt RIÊNG 1 học phần trong đợt (nút hiện khi rê chuột vào dòng).
     *  go=true → gỡ hẳn học phần khỏi mức thu, tổng phải nộp của đợt giảm theo. */
    HuyDuyetLopTheoSinhVien: (
        request: { id_sv: string; ky_dang_ky: number; id_lop_tcs: number[]; go: boolean },
        process_id: string,
    ) =>
        apiClient.put(
            `${MUC_THU_KHAC_SINH_VIEN}/huy-duyet-lop-theo-sinh-vien?process_id=${process_id}`,
            request,
        ),

    // ===== Lớp tự nguyện =====
    SelectLopTuNguyenTree: (request: ILopTuNguyenSelectRequest) =>
        apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-lop-tu-nguyen-tree`, request),
    SelectSinhVienByLopTc: (request: IDanhSachLopTinChiSelectByLopTcRequest) =>
        apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-sinh-vien-by-lop-tc`, request),
    GanMucThuLopTuNguyen: (request: IMucThuTinChiGanMucThuRequest) =>
        apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/gan-muc-thu-lop-tu-nguyen`, request),
    DuyetLopTuNguyen: (request: IMucThuTinChiDuyetLopTuNguyenRequest, process_id: string) =>
        apiClient.put(`${MUC_THU_KHAC_SINH_VIEN}/duyet-lop-tu-nguyen?process_id=${process_id}`, request),
    HuyDuyetLopTuNguyen: (request: IMucThuTinChiDuyetLopTuNguyenRequest, process_id: string) =>
        apiClient.put(`${MUC_THU_KHAC_SINH_VIEN}/huy-duyet-lop-tu-nguyen?process_id=${process_id}`, request),

    // ===== Tab tổng hợp theo lớp tín chỉ =====
    SelectTreeTatCaLopTinChi: (request: ILopTuNguyenSelectRequest) =>
        apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-lop-tu-nguyen-tree`, {
            ...request,
            chi_tu_nguyen: false,
        }),
    SelectSinhVienByLopTcs: (request: {
        hoc_ky: number;
        nam_hoc: string;
        id_lop_tcs: number[];
    }) =>
        apiClient.post(
            `${MUC_THU_KHAC_SINH_VIEN}/select-sinh-vien-by-lop-tcs`,
            request,
        ),
    /** ⚠ `trang_thai_tong_hop` = ô lọc "Trạng thái" trên lưới ("" | chua | da-tong-hop | da-duyet).
     *  KHÔNG truyền là chạy TOÀN BỘ node, lệch hẳn với số dòng đang hiển thị. */
    TongHopPreviewTheoNode: (request: {
        hoc_ky: number;
        nam_hoc: string;
        id_lop_tcs: number[];
        id_tts?: number[];
        id_lop_hanh_chinhs?: number[];
        tinh_chat_hocs?: number[];
        trang_thai_tong_hop?: string;
    }) =>
        apiClient.post(
            `${MUC_THU_KHAC_SINH_VIEN}/tong-hop-preview-theo-node`,
            request,
        ),
    /** "Áp dụng" cả node: chỉ tổng hợp (lưu mức thu), chưa duyệt/chưa tính công nợ. */
    TongHopTheoNode: (
        request: {
            hoc_ky: number;
            nam_hoc: string;
            id_lop_tcs: number[];
            id_tts?: number[];
            id_lop_hanh_chinhs?: number[];
            tinh_chat_hocs?: number[];
            id_thu_chi?: number;
            trang_thai_tong_hop?: string;
        },
        process_id: string,
    ) =>
        apiClient.put(
            `${MUC_THU_KHAC_SINH_VIEN}/tong-hop-theo-node?process_id=${process_id}`,
            request,
        ),
    TongHopTuDongTheoNode: (
        request: {
            hoc_ky: number;
            nam_hoc: string;
            id_lop_tcs: number[];
            id_tts?: number[];
            id_lop_hanh_chinhs?: number[];
            tinh_chat_hocs?: number[];
            id_thu_chi?: number;
            trang_thai_tong_hop?: string;
        },
        process_id: string,
    ) =>
        apiClient.put(
            `${MUC_THU_KHAC_SINH_VIEN}/tong-hop-tu-dong-theo-node?process_id=${process_id}`,
            request,
        ),

    // ===== Tab "Tổng hợp học phần miễn" =====
    SelectSinhVienMienByLopTcs: (request: {
        hoc_ky: number;
        nam_hoc: string;
        id_lop_tcs: number[];
    }) =>
        apiClient.post(
            `${MUC_THU_KHAC_SINH_VIEN}/select-sinh-vien-mien-by-lop-tcs`,
            request,
        ),
    /** Ép học phí học phần miễn = 0 + tính lại công nợ cho cả node. */
    TongHopHocPhanMienTheoNode: (
        request: {
            hoc_ky: number;
            nam_hoc: string;
            id_lop_tcs: number[];
            id_tts?: number[];
            id_lop_hanh_chinhs?: number[];
            tinh_chat_hocs?: number[];
            id_thu_chi?: number;
        },
        process_id: string,
    ) =>
        apiClient.put(
            `${MUC_THU_KHAC_SINH_VIEN}/tong-hop-hoc-phan-mien-theo-node?process_id=${process_id}`,
            request,
        ),

    // ===== Tab "Bổ sung học phần" =====
    SelectSinhVienBoSungByNode: (request: {
        hoc_ky: number;
        nam_hoc: string;
        id_lop_tcs: number[];
    }) =>
        apiClient.post(
            `${MUC_THU_KHAC_SINH_VIEN}/select-sinh-vien-bo-sung-by-node`,
            request,
        ),
    PreviewBoSungTheoNode: (request: {
        hoc_ky: number;
        nam_hoc: string;
        id_lop_tcs: number[];
        id_tts?: number[];
        id_lop_hanh_chinhs?: number[];
        tinh_chat_hocs?: number[];
        trang_thai_tong_hop?: string;
    }) =>
        apiClient.post(
            `${MUC_THU_KHAC_SINH_VIEN}/preview-bo-sung-theo-node`,
            request,
        ),
    /** Tổng hợp học phần bổ sung vào mức thu đợt. duyet=true → "Áp dụng và duyệt"; false → "Áp dụng". */
    TongHopBoSungTheoNode: (
        request: {
            hoc_ky: number;
            nam_hoc: string;
            id_lop_tcs: number[];
            id_tts?: number[];
            id_lop_hanh_chinhs?: number[];
            tinh_chat_hocs?: number[];
            id_thu_chi?: number;
            trang_thai_tong_hop?: string;
        },
        duyet: boolean,
        process_id: string,
    ) =>
        apiClient.put(
            `${MUC_THU_KHAC_SINH_VIEN}/tong-hop-bo-sung-theo-node?process_id=${process_id}&duyet=${duyet}`,
            request,
        ),

    // ===== Tab "Rút học phần" =====
    SelectSinhVienRutByNode: (request: {
        hoc_ky: number;
        nam_hoc: string;
        id_lop_tcs: number[];
    }) =>
        apiClient.post(
            `${MUC_THU_KHAC_SINH_VIEN}/select-sinh-vien-rut-by-node`,
            request,
        ),
    PreviewRutTheoNode: (request: {
        hoc_ky: number;
        nam_hoc: string;
        id_lop_tcs: number[];
        id_tts?: number[];
        id_lop_hanh_chinhs?: number[];
        tinh_chat_hocs?: number[];
        trang_thai_tong_hop?: string;
    }) =>
        apiClient.post(
            `${MUC_THU_KHAC_SINH_VIEN}/preview-rut-theo-node`,
            request,
        ),
    /** Gỡ học phần rút khỏi mức thu đợt. duyet=true → "Áp dụng và duyệt"; false → "Áp dụng". */
    /** Hủy duyệt (go_tong_hop=false) / hủy duyệt & gỡ (true) cho CẢ LỚP HÀNH CHÍNH ở một đợt. */
    HuyDuyetTheoLop: (
      request: {
        hoc_ky: number;
        nam_hoc: string;
        id_lops: number[];
        id_thu_chi: number;
        ky_dang_ky: number;
      },
      process_id: string,
      go_tong_hop: boolean,
    ) =>
      apiClient.put(
        `muc-thu-khac-tin-chi/huy-duyet-theo-lop?process_id=${process_id}&go_tong_hop=${go_tong_hop}`,
        request,
      ),

    /** Hủy duyệt (go=false) / hủy duyệt & gỡ (go=true) cho CẢ NODE lớp tín chỉ. */
    HuyDuyetLopTheoNode: (
      request: {
        id_lop_tcs: number[];
        id_tts?: number[];
        id_lop_hanh_chinhs?: number[];
        tinh_chat_hocs?: number[];
        id_thu_chi?: number;
      },
      process_id: string,
      go: boolean,
    ) =>
      apiClient.put(
        `muc-thu-khac-tin-chi/huy-duyet-lop-theo-node?process_id=${process_id}&go=${go}`,
        request,
      ),

    TongHopRutTheoNode: (
        request: {
            hoc_ky: number;
            nam_hoc: string;
            id_lop_tcs: number[];
            id_tts?: number[];
            id_lop_hanh_chinhs?: number[];
            tinh_chat_hocs?: number[];
            id_thu_chi?: number;
            trang_thai_tong_hop?: string;
        },
        duyet: boolean,
        process_id: string,
    ) =>
        apiClient.put(
            `${MUC_THU_KHAC_SINH_VIEN}/tong-hop-rut-theo-node?process_id=${process_id}&duyet=${duyet}`,
            request,
        ),

    // ===== Tab "Cập nhật mức thu quá hạn" (cây LỚP HÀNH CHÍNH → id_lops) =====
    SelectSinhVienQuaHanByNode: (request: {
        hoc_ky: number;
        nam_hoc: string;
        id_lops: number[];
    }) =>
        apiClient.post(
            `${MUC_THU_KHAC_SINH_VIEN}/select-sinh-vien-qua-han-by-node`,
            request,
        ),
    /** Tính lại học phí lớp năm cũ quá hạn theo đơn giá năm hiện tại + tính lại công nợ. */
    TongHopQuaHanTheoNode: (
        request: {
            hoc_ky: number;
            nam_hoc: string;
            id_lops: number[];
            id_tts?: number[];
            id_lop_hanh_chinhs?: number[];
            tinh_chat_hocs?: number[];
            id_thu_chi?: number;
        },
        process_id: string,
    ) =>
        apiClient.put(
            `${MUC_THU_KHAC_SINH_VIEN}/tong-hop-qua-han-theo-node?process_id=${process_id}`,
            request,
        ),

    // ===== Tab "Rà soát thu thừa (không còn lớp)" =====
    SelectThuThuaKhongLop: (request: IThuThuaKhongLopRequest) =>
        apiClient.post(
            `${MUC_THU_KHAC_SINH_VIEN}/select-thu-thua-khong-lop`,
            request,
        ),
    /** Tổng hợp lại + duyệt cho các mục thu bị thu thừa (hủy duyệt → dồn lại đúng → duyệt + công nợ). */
    TongHopLaiThuThua: (request: IThuThuaKhongLopRequest, process_id: string) =>
        apiClient.put(
            `${MUC_THU_KHAC_SINH_VIEN}/tong-hop-lai-thu-thua?process_id=${process_id}`,
            request,
        ),
};

/** Bộ lọc rà soát thu thừa (tất cả tùy chọn). */
export interface IThuThuaKhongLopRequest {
    id_hes?: number[];
    id_khoas?: number[];
    id_lops?: number[];
    /** (Đợt học) lọc theo nhiều đợt đăng ký (ky_dang_ky); rỗng = không lọc. */
    ky_dang_kys?: number[];
    nam_hoc?: string;
    hoc_ky?: number;
    search_key?: string;
    /** Id các MỤC THU đang tích chọn ở lưới; rỗng = làm cả danh sách đang lọc. */
    id_mucs?: number[];
}

/** 1 dòng = 1 mục thu học phí tín chỉ bị THU THỪA. */
export interface IThuThuaKhongLopVm {
    id: number;
    id_sv: string;
    ma_sv: string;
    ho_ten: string;
    ten_he: string;
    ten_lop: string;
    trang_thai_hoc: number;
    trang_thai_text: string;
    nam_hoc: string;
    hoc_ky: number;
    ky_dang_ky: number;
    dot: number;
    mo_ta_dot: string;
    so_tien_charge: number;
    so_tien_dung: number;
    lech: number;
    so_tien_da_nop: number;
    so_tien_con_lai: number;
    locked_duocthu: boolean;
    id_lop_tcs: string;
    /** true = mức thu nằm ở kỳ KHÁC kỳ hiện tại của đợt (đợt bị sửa kỳ) -> dòng mồ côi, nợ ảo. */
    lech_ky: boolean;
    loai: string;
}

/** 1 dòng xem trước = 1 HỌC PHẦN của 1 sinh viên (SV lỗi → 1 dòng is_error). */
export interface ITongHopPreviewSinhVien {
    id_sv: string;
    ma_sv: string;
    ho_ten: string;
    ten_lop: string;
    ky_dang_ky: number;
    id_lop_tc: number;
    hoc_lai: number;
    tinh_chat: string;
    ma_mon: string;
    ten_mon: string;
    ten_lop_hp: string;
    song_nganh: boolean;
    so_tin_chi: number;
    don_gia: number;
    so_tien: number;
    mien_giam: number;
    is_error: boolean;
    message: string;
}
